module.exports = __webpack_public_path__ + "static/media/image15.c2da2932.png";